export function detailsVisiblePrecisionReducer(state: number = 0): number {
  return state;
}
